import React, { useContext } from 'react'
import Export from '../../pdf/Export';
import ResultatTanzanie from './ResultatTanzanie';
import ResultatZambie from './ResultatZambie';
import { Spinner } from 'react-bootstrap';

function Resultat({ display, waiting, context, data }) {
    //const provider = useContext(RechercheContext)

    const printPdf = () => {
        switch (context) {
            case "zra":
                new Export().zraListe(data.data)
                break;

            default:
                break;
        }

    }

    const displayData = () => {
        if (data == null) {
            return <ResultatMessage text="Effectuez une recherche..." />
        }

        if (data.nombre == 0) {
            return <ResultatMessage text="Aucun résultat trouvé..." />
        }

        switch (context) {
            case "tra":
                return <ResultatTanzanie data={data} />
            case "zra":
                return <ResultatZambie data={data} />
            default:
                break;
        }

    }

    const spinner = () => {
        return (
            <div className='d-flex justify-content-center'>
                <Spinner />
            </div>
        )
    }

    return (
        <div className={'card card-body shadow' + (display ? '' : ' d-none')}>
            {waiting ? spinner() : displayData()}
        </div>
    )

    return waiting ? spinner() : displayData();
}

function ResultatMessage({ text }) {
    return (
        <div className=''>
            {text}
        </div>
    )
}

export default Resultat